<template>
  <div ref="map">
    <div id="wrapper" class="wrapper haslayout">
      <WebPortalHeader />
      <!--************************************
                    Main Start
            *************************************-->
      <main id="bg-main" class="bg-main Notice_mainsec">
        <!--************************************
                    DGME links Start
                *************************************-->
        <section class="haslayout st-shape-wrap">
          <div class="container-fluid">
            <div class="row">
              <div class="webportal-contant">
                <LeftSlider />
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="row">
                    <div class="mid_contant">
                      <div
                        class="
                          col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12
                          mt-5
                        "
                      >
                        <div class="row" id="Conten-details">
                          <div class="Content_details m-3">
                            <div class="Content-title">
                              <!--  {{getContentDetailsPublicData.content_url}} -->
                              <!-- {{getContentDetailsPublicData}} -->
                              <h2>{{ getContentDetailsPublicData.title }}</h2>
                            </div>
                          </div>
                          <div class="inner">
                            <div class="content">
                              <div
                                class="
                                  field
                                  field--name-field-date-released
                                  field--type-datetime
                                "
                              >
                                <time
                                  ><b>
                                    {{
                                      getContentDetailsPublicData.published_date
                                    }}</b
                                  ></time
                                >
                              </div>
                              <div
                                class="
                                  field
                                  field--name-body
                                  field--type-text-with-summary
                                "
                              >
                                <p
                                  v-html="
                                    getContentDetailsPublicData.description
                                  "
                                ></p>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              getContentDetailsPublicData.content_url != null
                                ? true
                                : false
                            "
                          >
                            <div
                              class="
                                video-player
                                col-xs-12 col-sm-12 col-md-12 col-lg-12
                              "
                            >
                              <div class="ytvid">
                                <div
                                  class="
                                    embed-responsive embed-responsive-16by9
                                  "
                                >
                                  <a :href="getContentUrl"></a>
                                  <iframe
                                    :key="getContentDetailsPublicData.title"
                                    id="vframe"
                                    title="Video Player"
                                    allowfullscreen="allowfullscreen"
                                    :src="`${getContentUrl}/${getContentDetailsPublicData.content_url}`"
                                    sandbox
                                  >
                                  </iframe>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="
                              col-xs-12 col-sm-12 col-md-12 col-lg-12
                              pull-right
                            "
                          >
                            <div class="commentsarea">
                              <div class="sectionhead">
                                <h2>
                                  {{
                                    getContentDetailsPublicData.comments_count
                                  }}
                                  {{
                                    getContentDetailsPublicData.comments_count <
                                    2
                                      ? "Comment"
                                      : "Comments"
                                  }}
                                </h2>
                              </div>
                              <template v-if="loggedInData.dgmeToken != 'null'">
                                <form>
                                  <img
                                    v-if="loggedInPic"
                                    class="style-scope yt-img-shadow"
                                    height="40"
                                    width="40"
                                    alt="image"
                                    :src="`${getContentUrl}/${this.loggedInData.user.profile_image}`"
                                  />
                                  <img
                                    v-if="!loggedInPic"
                                    class="style-scope yt-img-shadow"
                                    height="40"
                                    width="40"
                                    alt="image"
                                    src="../../assets/images/imag-27.jpg"
                                  />
                                  <input
                                    v-model="message"
                                    type="text"
                                    name="name"
                                    :disabled="!loggedInData.user"
                                    class="
                                      form-control
                                      border-bottom border_comment
                                    "
                                    placeholder="Add your Comment"
                                  />
                                </form>
                                <div class="float-right m-3">
                                  <button
                                    type="button"
                                    class="btn btn-light"
                                    @click="
                                      () => {
                                        this.message = '';
                                      }
                                    "
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-success"
                                    :disabled="!loggedInData.user"
                                    @click="postContentComment()"
                                  >
                                    COMMENT
                                  </button>
                                </div>
                              </template>
                              <div
                                v-if="loggedInData.dgmeToken == 'null'"
                                style="color: red; font-weight: bolder"
                              >
                                You need to login first to share your thoughts
                              </div>
                              <commentReply
                                :getContentDetailsPublic="
                                  getContentDetailsPublicData
                                "
                                :loggedInData="loggedInData"
                                @reloadContent="reloadContent"
                              ></commentReply>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <RightSlider />
              </div>
            </div>
          </div>
          <div class="st-shape2">
            <img src="../../assets/images/contact-shape1.svg" alt="shape2" />
          </div>
        </section>
        <!--************************************
                    DGME links Start
                *************************************-->
      </main>
      <!--************************************
                    Main End
            *************************************-->
      <WebPortalFooter @scrollToTop="goScrollTop()"> </WebPortalFooter>
    </div>
    <!-- <v-btn @click="goScrollTop()">TOP</v-btn> -->
  </div>
</template>

<script>
import WebPortalHeader from "../../components/webPortalLayout/WebPortalHeader.vue";
import LeftSlider from "../../components/webPortalLayout/LeftSlider";
import RightSlider from "../../components/webPortalLayout/RightSlider";
import WebPortalFooter from "../../components/webPortalLayout/WebPortalFooter";
import { baseURL2 } from "@/store/api.js";
import commentReply from "../../components/webPortalLayout/WebPortalCommentReply.vue";

export default {
  name: "Content",
  components: {
    WebPortalHeader,
    LeftSlider,
    RightSlider,
    WebPortalFooter,
    commentReply,
  },
  data() {
    return {
      contentComment: {
        portal_content_id: null,
        body: "",
      },
      loggedInData: {
        user: null,
        dgmeToken: null,
      },
      url_data: null,
      watchRed: 0,
      message: "",
    };
  },
  created() {
    this.loggedInData.user = JSON.parse(
      window.localStorage.getItem("currentUser")
    );
    this.loggedInData.dgmeToken = window.localStorage.getItem("dgmeToken");
    this.$store.dispatch("callHeaderFooterPublicData");
  },
  mounted() {
    let self = this;
    this.url_data = this.$route.params.id;
    this.$store.dispatch("callCotentDetailsByIdData", { id: this.url_data });
    self.$store.commit("SET_PORTAL_COMMENT_REPLY_CONFLICT_DATA", this.url_data);
  },
  watch: {},
  computed: {
    getContentDetailsPublicData() {
      let tempData = this.$store.getters.getContentDetailsPublicData;
      this.contentComment.portal_content_id = tempData.id;
      return tempData;
    },
    getContentUrl() {
      return baseURL2;
    },
    getDataForChange() {
      return this.$store.getters.getPortalCommentReplyConflictData;
    },
    loggedInPic() {
      return this.loggedInData.user && this.loggedInData.user.profile_image
        ? true
        : false;
    },
  },
  methods: {
    async postContentComment() {
      this.contentComment.body = this.message;
      await this.$store.dispatch("addPortalComment", this.contentComment);
      this.contentComment.body = "";
      this.watchRed = 0;
      let data = { id: this.getDataForChange };
      this.$store.dispatch("callCotentDetailsByIdData", data);
      return true;
    },
    async reloadContent() {
      // await this.$store.dispatch('callCotentDetailsByIdData', this.$route.params.id);
      ////  console.log("pushed", this.$route.params.id);
      // this.$emit('reloadContent', data);
      // this.watchRed = 0;
      let data = { id: this.getDataForChange };
      this.$store.dispatch("callCotentDetailsByIdData", data);
      // this.$router.go();
    },
    goScrollTop() {
      let scrollDiv = document.getElementById("wrapper");
      scrollDiv.scrollTop = 0;
      window.scrollTo(0, 0);
      this.$vuetify.goTo(0);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$refs.map.scrollToTop = 0;
      this.$el.scrollTop = 0;
     //  console.log("not working");
      document.body.scrollIntoView();
    },
  },
};
</script>

<style scoped>
.row {
  display: block;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
</style>
